import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import DatasetConvertToastComplete from '@/datasets/data/components/DatasetConvertToastComplete';
import DictionaryConvertToastComplete from '@/datasets/data/components/DictionaryConvertToastComplete';
import actions from '../constants';

export function* datasetConversionComplete({ entity }) {
  yield call(showToast, <DatasetConvertToastComplete datasetName={entity.name} />);
}

export function* dictionaryConversionComplete({ entity }) {
  yield call(showToast, <DictionaryConvertToastComplete dictionaryName={entity.name} />);
}

export default function* websocketToasts() {
  yield takeEvery(actions.WEBSOCKET_DATASET_CONVERSION_COMPLETE, datasetConversionComplete);
  yield takeEvery(actions.WEBSOCKET_DICTIONARY_CONVERSION_COMPLETE, dictionaryConversionComplete);
}
